import styled, { css } from 'styled-components'

interface ButtonProps {
    primary?: boolean
    rounded?: boolean
    fullWidth?: boolean
    secondary?: boolean
}

const Button = styled.button<ButtonProps>`
    text-decoration: none;
    background: transparent;
    font-weight: 600;
    font-size: 1rem;
    line-height: 1rem;
    display: block;
    text-align: center;
    padding: 1rem 2rem;
    ${({ primary }) =>
        primary &&
        css`
            background: ${({ theme }) => theme.colors.brand};
            color: ${({ theme }) => theme.colors?.white};
            border: none;
        `};

    ${({ rounded }) =>
        rounded &&
        css`
            border-radius: 2rem;
        `};

    ${({ fullWidth }) =>
        fullWidth &&
        css`
            width: 100%;
        `};

    ${({ secondary }) =>
        secondary &&
        css`
            color: ${({ theme }) => theme.colors.brand};
            border: 0.125rem solid
                ${({ theme }) => theme.colors.button.secondary};
        `};
`

export default Button
